/** AiDocAnalyzer - Create */
.accordionHeader {
    display: flex;
    align-items: center;
}

.fieldContainer {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
}

.fieldOneHalfWidth {
    flex: 0 1 calc(50% - 20px);
    min-width: 250px;
    max-width: calc(50% - 20px);
    margin: 0px;
}

.fieldOneThirdWidth {
    flex: 0 1 calc(33% - 20px);
    min-width: 250px;
    max-width: calc(33% - 20px);
}

.fieldAlignBottom {
    display: flex;
    align-items: flex-end;
}

.hrMargin {
    margin: 20px 0px;
}

.textMargin {
    margin: 8px 0px 0px 0px;
}

/** AiDocAnalyzer - Details */
.metadataSection {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
}
